export default "__VITE_ASSET__842c4e2e__"